<template>
  <el-config-provider :locale="locale">
    <div class="my_center_box" style="padding: 0 15%;margin-bottom: 10px">
      <el-row :gutter="20">
        <el-col :span="24" >
          <div class="top_box">
          </div>
        </el-col>
        <el-col :span="24" class="cz_user_box_t1">
          <div class="cz_user_box" style="background-color:white;width: 100%;height: 60px;margin-bottom: 14px;">
            <div  style="display: inline-block;line-height: 60px;float: left;margin-top: 14px;margin-left: 10px">
              <img class src="@/assets/index/tx@2x.png"
                   style="display: inline-block;margin-right: 5px;float: left;margin-top: 2px;width: 32px;" alt=""/>
              <div class="cz_user_info" style="display: inline-block;line-height: 30px;float: left">
                <span class="nickname_text">{{ nickname }}</span>
                <span v-if="expiration_date.slice(0, 4) === '2999' && this.acc_type === '0'"  class="expiration_date_text">
                  期限:永久
                </span>
                <span v-else class="expiration_date_text">{{
                    expiration_date.slice(0, 10)
                  }} 到期</span>


              </div>

            </div>
            <div class="my_center_top_right">
              <el-button class="xf_btn" v-if="my_xf_btn===true" type="primary" size="small"

                         @click="showBuy('zy')">
                立即续费
              </el-button>
              <el-button class="gm_btn" v-if="my_xf_btn===false" size="small"

                         @click="showBuy('zy')">
                立即购买
              </el-button>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4" >
          <div class="table_left" style="background-color: white;min-height: 600px">
            <div class="tab_btn" :class="tab_chose_class_1" @click="tab_click('1')">个人资料</div>
            <div class="tab_btn" :class="tab_chose_class_2" @click="tab_click('2')">设置密码</div>
            <div class="tab_btn" :class="tab_chose_class_3" @click="tab_click('3')">账户管理</div>
            <div class="tab_btn" :class="tab_chose_class_4" @click="tab_click('4')">线上开票</div>
          </div>
        </el-col>
        <el-col :span="20" style="padding-left: unset !important;">
          <div class="table_right" style="background-color: white;min-height: 600px">
            <div class="table_1" v-if="table_show===1">
              <!--个人资料-->
              <div class="profile_row profile_row_tx" style="margin-top: unset">
                <div class="profile_label">头像：</div>
                <div class="avatar_box">
                  <el-upload
                      class="avatar_uploader"
                      action="#"
                      :show-file-list="false"
                      :auto-upload="false"
                      accept="image/*"
                      :on-change="handleAvatarChange"
                  >
                    <img :src="avatarUrl" alt="avatar"
                         style="width:60px;height:60px;object-fit: cover;border-radius: 2px;cursor: pointer;">
                  </el-upload>
                </div>
              </div>

              <div class="profile_row">
                <div class="profile_label">昵称：</div>
                <div class="nickname_box inline_field">
                  <el-input v-model="nickname_edit" class="nc_input" placeholder="请输入昵称" style="width: 240px;color: #040404"></el-input>
                </div>
                <div class="profile_label">邀请码：</div>
                <div class="code_box" style="width: 110px;">
                  <span class="code_text">{{ user_code }}</span>
                  <img class="copy_icon" src="@/assets/index/fz@2x.png" alt="copy" @click="copyUserCode">
                </div>
              </div>

              <div class="profile_row">
                <div class="profile_label"></div>
                <el-button class="save_btn" type="primary" @click="saveProfile">保存</el-button>
              </div>

            </div>
            <div class="table_2" v-if="table_show===2">
              <!--设置密码-->
              <div class="pwd_row">
                <div class="pwd_label">旧密码：</div>
                <el-input
                    v-model="oldPwd"
                    class="pwd_input"
                    type="password"
                    placeholder="请输入当前密码"
                    show-password
                    style="width: 270px;"
                ></el-input>
              </div>
              <div class="pwd_row">
                <div class="pwd_label">新密码：</div>
                <el-input
                    v-model="newPwd"
                    class="pwd_input"
                    type="password"
                    placeholder="请输入新密码"
                    show-password
                    style="width: 270px;"
                ></el-input>
              </div>
              <div class="pwd_row">
                <div class="pwd_label">确认密码：</div>
                <el-input
                    v-model="confirmPwd"
                    class="pwd_input"
                    type="password"
                    placeholder="请再次输入新密码"
                    show-password
                    style="width: 270px;"
                ></el-input>
              </div>
              <div class="pwd_row">
                <div class="pwd_label"></div>
                <el-button class="reset_btn" type="primary" @click="resetPassword">确定重置</el-button>
              </div>
            </div>
            <div class="table_3" v-if="table_show===3">
              <div class="sim_balnce_box">
                <span class="balance_text">{{ formatAmount(balance) }}</span>
                <span class="zjwb_text">模拟资金</span>
                <el-button class="blance_xf_btn" type="primary" size="small" @click="showBuy('zy')">
                  续费
                </el-button>
              </div>
              <el-table
                  :data="re_gm_list"
                  style="width: 100%;color: #222222;"
                  :header-cell-style="{
                    color: '#7F7F7F',
                    backgroundColor:'#FAFAFA',
                    padding: '10px 0',
                    fontWeight: 400,
                    textAlign:'center'
                  }"
              >
                <el-table-column prop="order_type" label="购买类型" align="center" min-width="200">
                  <template #default="scope">
                    <span>{{ scope.row.product_zh }}</span>

                  </template>
                </el-table-column>
                <el-table-column prop="pay_time" label="购买时间" align="center" min-width="200">
                  <template #default="scope">
                    <span>{{ scope.row.pay_time.replace("T", " ") }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="pay_days" label="购买天数" align="center" width="200">
                </el-table-column>
<!--                <el-table-column prop="receipt_status_zh" label="使用状态" align="center" width="200">-->
<!--                </el-table-column>-->

                <el-table-column prop="pay_days" label="购买方式" align="center" width="200">
                  <template #default="scope">
                    <span>线上支付</span>
                  </template>
                </el-table-column>

                <el-table-column  v-if="show_refund_flag==='1'" label="操作" align="center" width="200">
                  <template #default="scope">
                    <span v-if="scope.row.refund == '0'"
                          style="cursor: pointer !important;color: #BA0B0B"
                          @click="applyRefund(scope.row)">申请退款</span>
                    <span v-else-if="scope.row.refund == '1'"
                          style="cursor: pointer !important;color: #BA0B0B"
                          >办理中</span>
                    <span v-else>退款完成</span>
                  </template>
                </el-table-column>

              </el-table>
            </div>

            <el-table class="table_4" v-if="table_show===4"
                      :data="re_gm_list"
                      style="width: 100%;color: #222222;"
                      :header-cell-style="{
                    color: '#7F7F7F',
                    backgroundColor:'#FAFAFA',
                    padding: '10px 0',
                    fontWeight: 400,
                    textAlign:'center'
                  }"
            >
              <el-table-column prop="product_zh" label="充值类型" align="center" min-width="200">
              </el-table-column>
              <el-table-column prop="pay_time" label="充值时间" align="center" min-width="200">
                <template #default="scope">
                  <span>{{ scope.row.pay_time.replace("T", " ") }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="pay_price" label="充值金额(元)" align="center" width="200">
              </el-table-column>
              <el-table-column prop="receipt_status" label="电子发票" align="center" width="200">
                <template #default="scope">
                  <span v-if="scope.row.receipt_status==='0'" style="cursor: pointer !important;color: #BA0B0B"
                        @click="sqkp_click(scope.row)">申请开票</span>
                  <span v-if="scope.row.receipt_status==='1'">开票中</span>
                  <span v-if="scope.row.receipt_status==='2'">邮件送达</span>
                  <span v-if="scope.row.receipt_status==='3'">退款</span>

                </template>

              </el-table-column>

            </el-table>
          </div>
        </el-col>

      </el-row>
    </div>



  </el-config-provider>

  <el-dialog

      v-model="dialogVisible"
      width="10rem"
      style="text-align: center"
  >
    <div style="height: 200px;text-align: center">
      <img style="width: 150px" src="../../assets/register/jszc_qr.png" alt="">
      <span style="display: block">{{ qr_title }}</span>
    </div>

  </el-dialog>

  <el-dialog
      v-model="sqkpShow"
      :width="isMobile ? '90%' : '20rem'"
      top="2rem"
      custom-class="invoice-dialog"
  >
    <template #title>
      <span style="font-size: 18px;color: #252525;float: left">申请开票</span>

    </template>
    <el-form ref="sqkpForm" :model="sqkpForm" label-width="150px" :rules="rules"
             style="display: flex;justify-content: center;">

      <div class="formGroupStyle">
        <div class="formTitle">
        </div>
        <div class="formMain mainMargin" style="color: #222222">
          <el-form-item label="发票类型：" class="widthAll labelHeight" prop="fplx">
            <span>{{ sqkpForm.fplx }}</span>
          </el-form-item>
          <el-form-item label="发票金额：" class="widthAll labelHeight" prop="fpje">
            <span>{{ sqkpForm.fpje }} 元</span>
          </el-form-item>
          <el-form-item label="抬头类型：" class="widthAll labelHeight" prop="ttlx">
            <el-radio v-model="sqkpForm.ttlx_radio" label="1" @change="ttlx_radio_change">个人</el-radio>
            <el-radio v-model="sqkpForm.ttlx_radio" label="2" @change="ttlx_radio_change">企业</el-radio>
          </el-form-item>
          <el-form-item label="发票抬头：" class="widthAll labelHeight" prop="fptt">
            <el-input
                v-model="sqkpForm.fptt"
                placeholder="请输入发票抬头"
                size="medium"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="this.sqkpForm.ttlx_radio=='2'" label="纳税人识别号：" class="widthAll labelHeight"
                        prop="nsrsbh">
            <el-input
                v-model="sqkpForm.nsrsbh"
                placeholder="请输入纳税人识别号"
            ></el-input>
          </el-form-item>
          <el-form-item label="发票内容：" class="widthAll labelHeight" prop="fpnr"
                        style="border-bottom: 1px dashed #CCCCCC">
            <span>{{ sqkpForm.fpnr }}</span>
          </el-form-item>
          <el-form-item label="电子邮箱：" class="widthAll labelHeight" prop="dzyx">
            <el-input
                v-model="sqkpForm.dzyx"
                placeholder="请输入电子邮箱"
            ></el-input>
            <spna style="font-size: 12px;color: #F1604C">此邮箱用于接收发票，请核实无误！</spna>
          </el-form-item>
        </div>
      </div>

    </el-form>
    <template #footer>
      <div class="kp_btn" style="margin-top: -60px">
        <el-button
            @click="sqkpShow = false"
            size="medium"
            type="danger" plain
        >取 消
        </el-button
        >
        <el-button type="danger" size="medium" @click="sqkpSend"
        >确 定
        </el-button
        >
      </div>

    </template>
  </el-dialog>

  <el-dialog
      v-model="buyBoxShow"
      :width="isMobile ? '90%' : '20rem'"
      top="2rem"
      custom-class="responsive-dialog"

  >
    <template #title class="cz_dialog">
      <span style="color: #2A2A2A;font-size: 14px;font-weight: 600;float: left;padding-top: 5px">充值账号：</span>
      <div class="cz_user_box" style="display: inline-block;line-height: 30px;float: left;margin-top: -4px">
        <img class src="@/assets/index/tx@2x.png"
             style="display: inline-block;margin-right: 5px;float: left;margin-top: 2px;width: 32px;" alt=""/>
        <div class="cz_user_info" style="display: inline-block;line-height: 30px;float: left">
          <span style="color: #666666;display: block;font-size: 14px;line-height: 14px;margin-bottom: 5px">{{
              username
            }}</span>
          <span v-if="expiration_date.slice(0, 4) === '2999' && this.acc_type === '0'" style="color: #9C9C9C;display: block;font-size: 12px;line-height: 12px">
            期限:永久
          </span>
          <span v-else style="color: #9C9C9C;display: block;font-size: 12px;line-height: 12px">{{
              expiration_date
            }} 到期</span>
        </div>

      </div>


    </template>
    <div class="version_card_box">

      <div class="version_card" :class="version_card_nk_00"
           @click="version_card_click(pay_price_bj,'1',365)">
        <span :class="version_card_nk_01">专业版</span>
        <span :class="version_card_nk_02">初始模拟资金100万</span>
        <span :class="version_card_nk_03">¥ <span :class="version_card_nk_04"
        >{{ pay_price_bj }}</span> 元
        <span v-if="zy_discount_flag==='1'" style="font-size: 12px;">限时{{zy_discount_rate }}折</span></span>

      </div>

    </div>

    <div class="version_pay_box" style="display: flex; flex-wrap: wrap; justify-content: center; max-width: 100%;">
      <div class="version_pay_left" >
        <div class="version_pay_qrcode">
          <div style="height: 120px"><img id="wx_tpid"
                                      :src="pay_qr_code"
                                      style="width: 120px;"></div>
          <div style="display: inline-block;height: 24px">
            <img src="@/assets/index/wx@2x.png" alt="" style="float: left;width: 24px;margin-right: 5px">
            <span style="float: left;line-height: 24px">微信扫码支付</span>
          </div>
        </div>
      </div>
      <div class="version_pay_right">
        <span style="display: block;color: #A9A9A9;line-height: 22px;">应付金额:</span>
        <span style="display: block;color: #EF4444;line-height: 30px;">¥ <span
            style="font-size: 32px;">{{ pay_price*zy_discount_rate/10 }}</span> 元</span>
        <span
            style="display: block;color: #434343;line-height: 12px;margin-bottom: 20px">*购买提示:一经使用，概不退费</span>
      </div>
    </div>
    <template #footer>

    </template>
  </el-dialog>

  <el-dialog
      v-model="buyReShow"
      width="13rem"
      top="2rem"
  >
    <div class="zf_success_box">

      <div class="success_1" style="text-align: center;height: 30px">
        <div style="display: inline-block;height: 36px">
          <img src="@/assets/index/zfcg@1x.png" alt="" style="float: left;width: 36px;margin-right: 5px">
          <span style="float: left;line-height: 36px;color: #232323">支付成功</span>
        </div>

      </div>
      <div class="success_2" style="color:#9C9C9C;text-align: center;height: 60px;line-height: 60px">
        可到“个人中心”一“账户管理”中查看详情
      </div>
      <div class="success_3" style="text-align: center">
        <el-button
            @click="showBuy('zy')"
            type="danger"
            size="medium" plain
        >继续购买
        </el-button
        >
        <el-button type="danger" size="medium" @click="buyReShow=false"
        >关 闭
        </el-button>
      </div>

    </div>

    <template #footer>

    </template>
  </el-dialog>

</template>
<script>
import {
  wx_zf_re, sys_user_me, order_bill_create, order_bill, update_receipt_info, sys_app_get_price,
  nickname_change, pwd_change, product_buy_list,product_price,product_refund
} from "@/api/system/system";


import zhCn from "element-plus/lib/locale/lang/zh-cn";
import {ElMessage, ElMessageBox} from "element-plus";


export default {
  components: {},
  data() {
    return {
      username: "",
      user_guid: "",
      nickname: "",
      balance: 0,
      acc_type: "",
      acc_type_zh: "",
      my_xf_btn: false,

      zx_qr_show: false,
      // 购买相关
      pay_price_jc: 0, //
      pay_price_bj: 0, //
      pay_days_jc: 0,
      pay_days_bj: 0,

      gr_sale_flag:"0",
      zy_sale_flag:"0",

      zy_discount_flag:"0",
      zy_discount_rate:10,

      buyBoxShow: false,
      my_version_class: "my_version_wx",  // my_version_yx有效  my_version_wx 无效
      version_name: "专业版",
      // // version_date: "2024-12-30到期",
      // version_date: "2024-11-30已过期",

      pay_price: 469, // 469 899
      pay_days: 180, // 469 899
      order_type: '0', // 0 基础 1 白金
      expiration_date: '--',
      userid: '',
      pay_qr_code: "",
      version_card_bnk_00: "version_card_chose",
      version_card_bnk_01: "",
      version_card_bnk_02: "",
      version_card_bnk_03: "",
      version_card_bnk_04: "",
      version_card_nk_00: "version_card_unset",
      version_card_nk_01: "",
      version_card_nk_02: "",
      version_card_nk_03: "",
      version_card_nk_04: "",
      buyReShow: false,
      zfjgTimerId: null,
      wx_ddh: "",
      // 购买相关结束

      locale: zhCn,
      dialogVisible: false,
      qr_title: "",

      tab_chose_class_1: "tab_chose",
      tab_chose_class_2: "tab_no_chose",
      tab_chose_class_3: "tab_no_chose",
      tab_chose_class_4: "tab_no_chose",
      table_show: 1,
      re_gm_list: [],
      show_refund_flag: '0',
      sqkpShow: false,
      sqkpForm: {
        order_id: "",
        fplx: "增值税普通发票",
        fplx_num: "1", // 1:增值税普通发票
        fpje: 0,
        fpnr: "服务",
        ttlx_radio: "1", // 1个人 2企业
        fptt: "个人",
        nsrsbh: "",
        dzyx: "",

      },
      // 个人资料编辑
      avatarUrl: require('@/assets/index/tx@2x.png'),
      nickname_edit: '',
      user_code: '00000000',
      // 重置密码
      oldPwd: '',
      newPwd: '',
      confirmPwd: '',
      rules: {
        ttlx_radio: [{required: true, message: '选择抬头类型', trigger: 'blur'},],
        fptt: [{required: true, message: '输入发票抬头', trigger: 'blur'},],
        nsrsbh: [{required: true, message: '输入纳税人识别号', trigger: 'blur'},],
        dzyx: [{required: true, message: '输入电子邮箱', trigger: 'blur'},],
      },

    }
        ;
  },
  methods: {
    formatAmount(value) {
      if (value === null || value === undefined || value === '') {
        return '0';
      }
      const num = Number(value);
      if (isNaN(num)) {
        return String(value);
      }
      return num.toLocaleString('zh-CN');
    },

    // 头像本地预览
    handleAvatarChange(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.avatarUrl = e.target.result;
      };
      reader.readAsDataURL(file.raw || file);
    },
    // 复制用户代码
    copyUserCode() {
      const text = this.user_code;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          ElMessage({message: '复制成功', type: 'success'});
        }).catch(() => {
          this.fallbackCopyText(text);
        });
      } else {
        this.fallbackCopyText(text);
      }
    },
    fallbackCopyText(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      ElMessage({message: '复制成功', type: 'success'});
    },
    // 保存资料
    saveProfile() {
      // 这里保留为本地更新，如后续接入接口可在此提交
      // this.nickname = this.nickname_edit || this.nickname;
      var data_parm = {
        user_guid: this.username,
        nickname: this.nickname_edit
      };
      nickname_change(data_parm).then(
          (res) => {
            // console.log("==nickname_change==", res.data);
            // ElMessage({message: '保存成功', type: 'success'});
            // location.reload();
            ElMessage({message: '保存成功', type: 'success'});
          },
          (error) => {
            if (error.toString().includes('403')) {
              ElMessage({
                showClose: true,
                message: "保存失败!",
                type: "warning",
              });

            } else {
              ElMessage({
                showClose: true,
                message: error,
                type: "warning",
              });
            }

          }
      );


    },

    // 重置密码
    resetPassword() {
      if (!this.oldPwd || !this.newPwd || !this.confirmPwd) {
        ElMessage({message: '请完整填写密码', type: 'warning'});
        return;
      }
      if (this.newPwd !== this.confirmPwd) {
        ElMessage({message: '两次输入的新密码不一致', type: 'warning'});
        return;
      }
      // TODO: 接入后端接口提交重置密码
      var data_parm = {
        user_guid: this.username,
        old_password: this.oldPwd,
        new_password: this.newPwd
      };

      pwd_change(data_parm).then(
          (res) => {
            console.log("==pwd_change==", res.data);
            ElMessage({message: '重置成功', type: 'success'});

          },
          (error) => {
            if (error.toString().includes('403')) {
              ElMessage({
                showClose: true,
                message: "密码重置失败!",
                type: "warning",
              });

            } else {
              ElMessage({
                showClose: true,
                message: error,
                type: "warning",
              });
            }

          }
      );


      this.oldPwd = '';
      this.newPwd = '';
      this.confirmPwd = '';


    },

    to_index() {
      this.$router.push({path: "/index", query: {type: 1}});
    },
    zxMouseOver() {
      this.zx_qr_show = true;
    },
    zxMouseOut() {
      this.zx_qr_show = false;
    },
    buy_click(t) {
      this.dialogVisible = true;
      this.qr_title = t
    },
    tab_click(tab_num) {
      if (tab_num === '1') {
        this.tab_chose_class_1 = "tab_chose";
        this.tab_chose_class_2 = "tab_no_chose";
        this.tab_chose_class_3 = "tab_no_chose";
        this.tab_chose_class_4 = "tab_no_chose";
        this.table_show = 1;

        // 查询专业版记录
        // this.get_order_bill()

      } else if (tab_num === '2') {
        this.tab_chose_class_1 = "tab_no_chose";
        this.tab_chose_class_2 = "tab_chose";
        this.tab_chose_class_3 = "tab_no_chose";
        this.tab_chose_class_4 = "tab_no_chose";
        this.table_show = 2;

        // 查询专业版记录
        // this.get_order_bill()

      } else if (tab_num === '3') {
        this.tab_chose_class_1 = "tab_no_chose";
        this.tab_chose_class_2 = "tab_no_chose";
        this.tab_chose_class_3 = "tab_chose";
        this.tab_chose_class_4 = "tab_no_chose";
        this.table_show = 3;

        // 查询专业版记录
        this.get_order_bill()

      } else if (tab_num === '4') {
        this.tab_chose_class_1 = "tab_no_chose";
        this.tab_chose_class_2 = "tab_no_chose";
        this.tab_chose_class_3 = "tab_no_chose";
        this.tab_chose_class_4 = "tab_chose";
        this.table_show = 4;

        // 查询专业版记录
        this.get_order_bill()

      } else {
        this.tab_chose_class_1 = "tab_chose";
        this.tab_chose_class_2 = "tab_no_chose";
        this.tab_chose_class_3 = "tab_no_chose";
        this.tab_chose_class_4 = "tab_no_chose";
        this.table_show = 1;
      }

    },

    // 查询专业版记录
    get_order_bill() {
      var data_parm = {
        user_guid: this.username
      };
      product_buy_list(data_parm).then(
          (res) => {
            console.log("==product_buy_list==", res.data.data.product_buy_log);
            this.re_gm_list = (res.data.data.product_buy_log || []).map(item => ({...item, _refundApplying: false}))

            this.show_refund_flag = res.data.data.show_refund
            console.log("==re_gm_list==", this.re_gm_list);
            console.log("this.show_refund_flag", this.show_refund_flag);
          },
          (error) => {
            if (error.toString().includes('403')) {
              ElMessage({
                showClose: true,
                message: "登陆失效，请重新登录!",
                type: "warning",
              });

            } else {
              ElMessage({
                showClose: true,
                message: error,
                type: "warning",
              });
            }

          }
      );
    },
    applyRefund(row) {

      ElMessageBox.confirm('确认申请退款？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'tk-confirm-dialog', // 添加自定义类名用于响应式样式
      }).then(() => {
        var data = {
          "order_id": row.order_id
        };
        product_refund(data).then(
          (res) => {
            console.log("==product_refund==", res.data.data);
            ElMessage({ message: '已提交退款申请', type: 'success' });
            location.reload();
          },
          (error) => {
            ElMessage({
              showClose: true,
              message: error,
              type: "warning",
            });
          }
        );

      }).catch(() => {});
    },

    sqkp_click(kp_row) {
      this.sqkpShow = true;
      this.sqkpForm.order_id = kp_row.order_id;
      this.sqkpForm.fpje = kp_row.pay_price;
      if (this.sqkpForm.receipt_head === '1') {
        this.sqkpForm.fptt = "个人";
        this.sqkpForm.nsrsbh = this.username;
      } else {
        this.sqkpForm.fptt = "";
        this.sqkpForm.nsrsbh = "";
      }
    },
    // 申请开票
    sqkpSend() {
      var parm_data = {
        order_id: this.sqkpForm.order_id,
        receipt_head_type: this.sqkpForm.ttlx_radio,
        receipt_head: this.sqkpForm.fptt,
        receipt_ns_num: this.sqkpForm.nsrsbh,
        receipt_address: this.sqkpForm.dzyx,
      }
      update_receipt_info(parm_data).then(
          (res) => {
            console.log("==update_receipt_info==",res.data);

          },
          (error) => {
            console.log(error);
            if (error.toString().includes('403')) {
              ElMessage({
                showClose: true,
                message: "提交失败",
                type: "warning",
              });

            } else {
              ElMessage({
                showClose: true,
                message: error,
                type: "warning",
              });
            }

          }
      );
      this.sqkpShow = false;
      this.get_order_bill()

    },
    ttlx_radio_change() {
      if (this.sqkpForm.ttlx_radio === '1') {
        this.sqkpForm.fptt = "个人";
        this.sqkpForm.nsrsbh = this.username;
      } else {
        this.sqkpForm.fptt = "";
        this.sqkpForm.nsrsbh = "";
      }
    },
    // receipt_download(url) {
    //   window.open(require("/static/files/fp_test.pdf"));
    //   // window.open(require("../../assets/files/fp_test.pdf"));
    // },

    //打开支付弹框
    showBuy(buy_type) {
      if (buy_type === 'gr'){
        if(this.gr_sale_flag === '0'){
          ElMessage({
            showClose: true,
            message: '暂未开售',
            type: "warning",
          });
          return
        }
      }
      if (buy_type === 'zy'){
        if(this.zy_sale_flag === '0'){
          ElMessage({
            showClose: true,
            message: '暂未开售',
            type: "warning",
          });
          return
        }
      }

      this.buyBoxShow = true;
      this.buyReShow = false;
      this.version_card_click(this.pay_price_bj, '1', 365);

    },

    // 查询支付结果
    wx_zf_re_f() {
      var zf_re_url = "http://payapi.yogoo.net/wxzf/result/" + this.wx_ddh.toString() + ".json";
      wx_zf_re(zf_re_url).then(
          (res) => {
            // console.log("=res===", res);
            var res_str = res.data.toString();
            // console.log("=res1===", res_str);
            // console.log("=res2===", res_str.includes("Success"));
            // console.log("=res2===", res_str.includes(this.wx_ddh.toString()));

            // this.wx_ddh = "T2024126163137";
            if (res_str.includes("Success") && res_str.includes(this.wx_ddh.toString())) {
              // if (1===1) {
              if (this.zfjgTimerId) {
                clearInterval(this.zfjgTimerId);
                this.buyBoxShow = false;
                this.buyReShow = true;

                const now = new Date();
                const year = now.getFullYear();
                const month = (now.getMonth() + 1).toString().padStart(2, '0');
                const day = now.getDate().toString().padStart(2, '0');
                const hours = now.getHours().toString().padStart(2, '0');
                const minutes = now.getMinutes().toString().padStart(2, '0');
                const seconds = now.getSeconds().toString().padStart(2, '0');
                var pay_date = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

                var data = {
                  user_guid: this.username,
                  // 订单号
                  order_id: this.wx_ddh,
                  // 订单类型
                  product_id: this.order_type,
                  // 订单金额
                  pay_price: this.pay_price*this.zy_discount_rate/10,
                  // 订单折扣
                  discount_rate: this.zy_discount_rate,
                  // 付款时间
                  pay_time: pay_date,
                  // 付款类型
                  pay_type: "0",
                  pay_days: "365",

                };
                // 支付记录传入后台
                order_bill_create(data).then(
                    (res) => {
                      console.log(res.data.meta);
                      if (res.data.meta.code == 200) {
                        console.log("订单支付成功");
                        //  ElMessage({
                        //   showClose: true,
                        //   message: "订单支付成功",
                        //   type: "warning",
                        // });
                        location.reload();
                      } else {
                        console.log("订单支付异常");
                        // ElMessage({
                        //
                        //   showClose: true,
                        //   message: "订单支付异常",
                        //   type: "warning",
                        // });
                      }
                    },
                    (error) => {

                      ElMessage({
                        showClose: true,
                        message: "订单支付失败",
                        type: "warning",
                      });
                      console.log(error);
                    }
                );

              }

              // console.log("==this.zfjgTimerId==",this.zfjgTimerId)
            }

          },
          (error) => {
            console.log(error);
          }
      );
      if (!this.buyBoxShow) {
        if (this.zfjgTimerId) {
          clearInterval(this.zfjgTimerId);
        }
      }
    },

    // 购买订单qr生成
    version_card_click(pay_price, pay_type, pay_days) {
      if (this.zfjgTimerId) {
        clearInterval(this.zfjgTimerId);
      }
      const now = new Date();
      const year = now.getFullYear().toString().padStart(2, '0');
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const day = now.getDate().toString().padStart(2, '0');
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      const seconds = now.getSeconds().toString().padStart(2, '0');

      // console.log(`${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      this.order_type = pay_type;
      this.pay_price = pay_price;
      this.pay_days = pay_days;
      var ddg_date = year.toString() + month.toString() + day.toString() + hours.toString() + minutes.toString() + seconds.toString();
      this.wx_ddh = "T" + ddg_date.toString() + this.userid;
      this.pay_qr_code =
          "http://payapi.yogoo.net/wxzf/zfcs/MakeQRCode.aspx?wx_body=悦宝平台订单&wx_total_fee=" + this.pay_price *this.zy_discount_rate/10 * 100 +
          "&wx_ddh=" + this.wx_ddh;
      if (pay_type === '0') {
        this.version_card_bnk_00 = "version_card_chose";
        this.version_card_bnk_01 = "version_card_chose_01";
        this.version_card_bnk_02 = "version_card_chose_02";
        this.version_card_bnk_03 = "version_card_chose_03";
        this.version_card_bnk_04 = "version_card_chose_04";

        this.version_card_nk_00 = "version_card_unset";
        this.version_card_nk_01 = "version_card_unset_01";
        this.version_card_nk_02 = "version_card_unset_02";
        this.version_card_nk_03 = "version_card_unset_03";
        this.version_card_nk_04 = "version_card_unset_04";
      } else {
        this.version_card_bnk_00 = "version_card_unset";
        this.version_card_bnk_01 = "version_card_unset_01";
        this.version_card_bnk_02 = "version_card_unset_02";
        this.version_card_bnk_03 = "version_card_unset_03";
        this.version_card_bnk_04 = "version_card_unset_04";

        this.version_card_nk_00 = "version_card_chose";
        this.version_card_nk_01 = "version_card_chose_01";
        this.version_card_nk_02 = "version_card_chose_02";
        this.version_card_nk_03 = "version_card_chose_03";
        this.version_card_nk_04 = "version_card_chose_04";

      }

      // 创建定时器，每2秒执行一次updateMessage方法
      this.zfjgTimerId = setInterval(this.wx_zf_re_f, 2000);

    },

    // 个人信息查询
    get_sys_user_me() {
      sys_user_me().then(
          (res) => {
            console.log("==get_sys_user_me==", res)
            this.username = res.data.data[0]["user_guid"];
            this.nickname = res.data.data[0]["username"];
            this.balance = res.data.data[0]["balance"];
            this.nickname_edit = this.nickname;
            // 若后端返回固定8位代码，可在此覆盖 user_code
            if (res.data.data[0]["user_code"]) {
              this.user_code = (res.data.data[0]["user_code"] + '').padStart(8, '0').slice(-8);
            } else {
              // 默认以 user_guid 的末8位作为展示
              const ug = (this.username + '').replace(/[^\d]/g, '');
              this.user_code = (ug.slice(-8) || '00000000').padStart(8, '0');
            }
            this.acc_type_zh = res.data.data[0]["acc_type_zh"];
            this.acc_type = res.data.data[0]["acc_type"];
            this.userid = res.data.data[0]["user_guid"];
            this.expiration_date = res.data.data[0]["expired_time"].toString().slice(0, 10);

            if (res.data.data[0]["acc_type"] === '1') {
              this.my_version_class = "my_version_yx";
              this.my_xf_btn = true;
            } else {
              this.my_version_class = "my_version_wx";
              this.my_xf_btn = false;
            }


          },
          (error) => {
            ElMessage({
              showClose: true,
              message: error,
              type: "warning",
            });
          }
      );
    },
    // 授权书下载
    download() {
      // <a  href ="/static/files/fp_test.pdf"  download = "发票" style="color: #409EFF;float: right;margin-left: 10px">发票</a>
      //     <a  href ="/static/files/wordsTemplate.txt"  download = "发票2" style="color: #409EFF;float: right;margin-left: 10px">发票2</a>
      // 通过a标签来实现下载
      var a = document.createElement("a") //创建一个<a></a>标签
      a.href = "/static/files/wordsTemplate.txt" //给a标签的href属性值加上地址，注意，这里是绝对路径，不用    加 点.
      a.download = "wordsTemplate.txt" //设置下载文件文件名，这里加上.docx指定文件类型，pdf文件就指定.pdf即可
      a.style.display = "none" //隐藏a标签
      document.body.append("a") //将a标签追加到document.body中
      a.click() //模拟点击a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove() // 删除a标签（一次性的）
    },

    // 查询年卡、半年卡 价格
    get_sys_app_get_price() {
      var data = {
        "product_id": '0'
      };
      product_price(data).then(
          (res) => {
            // console.log("==product_price=1=",res.data.data)
            this.pay_price_jc = res.data.data.price_num;
            this.gr_sale_flag = res.data.data.sale_flag;
          },
          (error) => {
            ElMessage({
              showClose: true,
              message: error,
              type: "warning",
            });
          }
      );

      var data2 = {
        "product_id": '1'
      };
      product_price(data2).then(
          (res) => {
            this.pay_price_bj = res.data.data.price_num;
            this.zy_sale_flag = res.data.data.sale_flag;
            this.zy_discount_flag = res.data.data.discount_flag;
            if (res.data.data.discount_flag === '1'){
              this.zy_discount_rate = res.data.data.discount_rate;
            }
          },
          (error) => {
            ElMessage({
              showClose: true,
              message: error,
              type: "warning",
            });
          }
      );

    },

  },
  created() {
    this.get_sys_user_me();
    // this.get_order_bill();
    this.get_sys_app_get_price();
  },
};

</script>


<style scoped>

  :deep(.el-message) {
    max-width: 90% !important;
    min-width: unset !important;
    margin: 0 auto !important;
    color: red !important;
  }
  :deep(.el-message--success) {
    max-width: 90% !important;
    min-width: unset !important;
    margin: 0 auto !important;
    color: red !important;
  }
  ::v-deep .el-message {
    max-width: 10% !important;
    min-width: unset !important;
    margin: 0 auto !important;
    color: red !important;
  }


  :deep(.el-dialog__header) {
    border-bottom: 1px solid #E9E9E9 !important;
    padding-top: unset !important;
    padding-bottom: unset !important;
    line-height: 68px !important;
  }
  .cz_dialog{
    border-bottom: 1px solid #E9E9E9 !important;
    padding-top: unset !important;
    padding-bottom: unset !important;
    line-height: 68px !important;
  }


  .top_box {
    font-size: 14px;
    color: #6A6A6A;
    margin-top: 10px;
    margin-bottom: 10px;
    height: 10px;
  }

  .back_box {
    position: fixed;
    right: 40px;
    bottom: 140px;
    font-size: 100px;
    background-image: url(../../assets/index/back.png);
    background-size: 100% 100%;
    width: 54px;
    height: 54px;
  }

  .zx_mr_box {
    position: fixed;
    right: 40px;
    bottom: 200px;
    font-size: 100px;
    background-image: url(../../assets/index/zx-mr.png);
    background-size: 100% 100%;
    width: 54px;
    height: 54px;
  }

  .zx_xf_box {
    position: fixed;
    right: 40px;
    bottom: 200px;
    font-size: 100px;
    background-image: url(../../assets/index/zx-xf.png);
    background-size: 100% 100%;
    width: 54px;
    height: 54px;
  }

  .zx_qr_box {
    position: fixed;
    right: 120px;
    bottom: 150px;
    width: 100px;
    height: 120px;
    border: 10px solid white;
    background-color: white;
    color: #7E7E7E;

  }

  .tab_btn {

    font-size: 14px;
    line-height: 32px;
    padding-left: 10px;
  }

  .tab_chose {
    border-left: 3px solid #BA0B0B;
    color: #BA0B0B;
    background: #FEEFEF;
    font-weight: 400;
  }

  .tab_no_chose {
    border-left: 3px solid white;
    font-weight: 400;
  }

  /deep/ .el-form-item__label {
    color: #222222;
  }

  /deep/ .el-radio__label {
    color: #222222;
  }

  /*支付相关开始*/
  .version_card_box {
    height: 150px;
    text-align: center;
    margin: 0 auto;
    border-bottom: solid 1px #EEEEEE;
    margin-bottom: 20px;
  }

  .version_card {
    text-align: center;
    width: 180px;
    height: 100px;
    padding-top: 20px;
    border-radius: 5px;
  }

  .version_pay_box {
    height: 180px;
    width: 400px;
    margin: 0 auto;
  }

  .version_pay_qrcode {
    width: 140px;
    height: 155px;
    border: solid 1px #EEEEEE;
    padding: 10px;
    text-align: center;
    float: left;
  }

  .version_pay_right {
    width: 200px;
    height: 155px;
    float: left;
    padding-top: 20px;
    padding-left: 20px;
  }

  .version_card_chose {
    background-color: #FDECEC;
    border: 1px solid #F37070;
    width: 25%;
    margin-left: auto;
    margin-right: auto;
    display: inline-block; /* 或 display: block; */
  }

  .version_card_unset {
    background-color: #FFFFFF;
    border: 1px solid #D2D2D2
  }

  .version_card_chose_01 {
    display: block;
    color: #682020;
    line-height: 22px;
  }

  .version_card_chose_02 {
    display: block;
    color: #682020;
    line-height: 14px;
    margin-bottom: 10px
  }

  .version_card_chose_03 {
    display: block;
    color: #EF4444;
    line-height: 30px;
  }

  .version_card_chose_04 {
    font-size: 18px;
    font-weight: 600
  }

  .version_card_unset_01 {
    display: block;
    color: #717171;
    line-height: 22px;
  }

  .version_card_unset_02 {
    display: block;
    color: #717171;
    line-height: 14px;
    margin-bottom: 10px
  }

  .version_card_unset_03 {
    display: block;
    color: #222222;
    line-height: 30px;
  }

  .version_card_unset_04 {
    font-size: 18px;
    font-weight: 600
  }


  /*支付相关结束*/

  .profile_row {
    display: flex;
    align-items: center;
    margin: 12px 0;
  }

  .profile_label {
    width: 60px;
    font-size: 14px;
    color: #040404;
    font-weight: 400;
  }

  .avatar_box {
    display: inline-flex;
    align-items: center;
  }

  .nickname_box {
    display: inline-flex;
    align-items: center;
  }

  .inline_field {
    margin-right: 24px;
  }

  .code_box {
    display: inline-flex;
    height: 38px;
    align-items: center;
    border: 1px solid #E5E5E5;
    padding: 0 8px 0 12px;
    border-radius: 4px;
    color: #040404;
    font-size: 14px;

  }

  .code_text {
    letter-spacing: 2px;
  }

  .copy_icon {
    width: 16px;
    height: 16px;
    margin-left: 8px;
    cursor: pointer;
  }

  .save_btn {
    background-color: #BA0B0B;
    border-color: #BA0B0B;
    color: #FFFFFF;
    border-radius: 4px;
    width: 98px;
    height: 32px;
    font-size: 14px;
    margin-top: 10px;
  }

  /deep/ .save_btn:hover,
  /deep/ .save_btn:focus,
  /deep/ .save_btn:active {
    background-color: #BA0B0B !important;
    border-color: #BA0B0B !important;
    color: #FFFFFF !important;
    box-shadow: none !important;
  }

  /* 重置密码 */
  .pwd_row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .pwd_label {
    width: 70px;
    color: #040404;
    font-size: 14px;
    font-weight: 400;
  }

  :deep(.el-input__inner:focus) {
    border-color: #BA0B0B;
  }
  :deep(.el-input__inner) {
    color: #040404;
    font-size: 14px;
  }

  .pwd_input :deep(.el-input__wrapper) {
    height: 38px;
    border-radius: 2px;
    box-shadow: none;
    border: 1px solid #E7E7E7;
  }

  .pwd_input :deep(.el-input__inner) {
    color: #040404;
    font-size: 14px;
  }
  .nc_input :deep(.el-input__inner) {
    color: #040404;
  }
  .nc_input :deep(.el-input__inner:focus) {
    border-color: #BA0B0B;
  }

  .pwd_input :deep(.el-input__inner::placeholder) {
    color: #ADADAD;
  }
  .pwd_input :deep(.el-input__inner:focus) {
    border-color: #BA0B0B;
  }

  .reset_btn {
    background-color: #BA0B0B;
    border-color: #BA0B0B;
    color: #FFFFFF;
    border-radius: 4px;
    width: 98px;
    height: 32px;
    font-size: 14px;
    margin-top: 10px;
  }

  /deep/ .reset_btn:hover,
  /deep/ .reset_btn:focus,
  /deep/ .reset_btn:active {
    background-color: #BA0B0B !important;
    border-color: #BA0B0B !important;
    color: #FFFFFF !important;
    box-shadow: none !important;
  }

  .nickname_text {
    color: #040404;
    display: block;
    font-size: 16px;
    line-height: 16px;
    font-weight: 400;
    margin-bottom: 5px
  }

  .expiration_date_text {
    color: #777777;
    display: block;
    font-size: 12px;
    line-height: 12px;
    font-weight: 400;
  }

  .xf_btn {
    background-color: #BA0B0B;
    border-color: #BA0B0B;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 400;
    float: right;
    margin-right: 10px;
    margin-top: 13px;
    width: 100px;
    border-radius: 4px;
  }

  /deep/ .xf_btn:hover,
  /deep/ .xf_btn:focus,
  /deep/ .xf_btn:active {
    background-color: #BA0B0B !important;
    border-color: #BA0B0B !important;
    color: #FFFFFF !important;
    box-shadow: none !important;
  }

  .gm_btn {
    font-size: 14px;
    font-weight: 400;
    float: right;
    margin-right: 10px;
    margin-top: 13px;
    width: 100px
  }

  /deep/ .gm_btn:hover,
  /deep/ .gm_btn:focus,
  /deep/ .gm_btn:active {
    background-color: #FFFFFF !important;
    border-color: #BA0B0B !important;
    color: #BA0B0B !important;
    box-shadow: none !important;
  }

  .table_1 {
    padding-left: 30px;
    padding-top: 30px;
  }

  .table_2 {
    padding-left: 30px;
    padding-top: 30px;
  }

  /* 模拟资金展示 */
  .sim_balnce_box {
    text-align: center;
    padding: 16px 0;
  }

  .sim_balnce_box .balance_text {
    display: block;
    color: #BA0B0B;
    font-size: 20px;
    line-height: 34px;
    font-weight: bold;
  }

  .sim_balnce_box .zjwb_text {
    display: block;
    color: #777777;
    font-size: 14px;
    line-height: 20px;
    margin-top: 4px;
    font-weight: 400;
  }

  .sim_balnce_box .blance_xf_btn {
    float: none;
    display: inline-block;
    margin: 10px auto 0;
  }

  .blance_xf_btn {
    background-color: #BA0B0B;
    border-color: #BA0B0B;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 400;
    float: right;
    margin-right: 10px;
    margin-top: 13px;
    width: 98px;
    height: 32px;
    border-radius: 4px;
  }

  /deep/ .el-table__body {
    width: unset !important;
  }

  /deep/ .el-table__header {
    width: unset !important;
  }
  /deep/ .el-table__empty-block {
    width: unset !important;
  }

  /deep/ .el-radio__input.is-checked .el-radio__inner{
    background-color: #BA0B0B;
    border-color: #BA0B0B;
  }
  /deep/ .el-radio__input.is-checked+.el-radio__label{
    color: #BA0B0B;
  }

  /* 响应式媒体查询 */
  @media (max-width: 1200px) {
    .cz_user_box {
      padding: 0 10px !important;
    }

    .table_1, .table_2 {
      padding-left: 20px;
      padding-top: 20px;
    }

    .el-col-4, .el-col-20 {
      padding: 0 10px !important;
    }
  }

  @media (max-width: 768px) {
    /* 外层容器调整 */
    div[style*="padding: 0 15%"] {
      padding: 0 30px !important;
    }
    .my_center_box{
      padding: 0 30px !important;
    }

    /* 用户信息框 */
    .cz_user_box {
      height: auto !important;
      padding: 10px !important;
      flex-direction: column;
      align-items: flex-start !important;
      width: unset !important;
    }
    .cz_user_box_t1{
      padding: unset !important;
    }

    .cz_user_box > div:first-child {
      float: none !important;
      margin: 0 !important;
      display: flex;
      align-items: center;
      width: 100%;
    }

    .cz_user_info {
      float: none !important;
      display: flex !important;
      flex-direction: column !important;
    }

    .my_center_top_right {
      margin-top: 10px !important;
    }

    .xf_btn, .gm_btn {
      float: none !important;
      margin: 0 !important;
      width: 100% !important;
    }

    /* 左右布局改为上下布局 */
    .el-col-4, .el-col-20 {
      flex: 0 0 100% !important;
      max-width: 100% !important;
      padding: 0 !important;
    }


    /* 侧边栏水平显示 */
    .table_left {
      min-height: auto !important;
      display: flex !important;
      flex-direction: row !important;
      background-color: white;
      margin-bottom: 10px;
      overflow-x: visible; /* 移除滚动条 */
      flex-wrap: wrap; /* 允许内容换行 */
    }

    .tab_btn {
      flex: 1 0 auto;
      text-align: center;
      padding: 8px 5px !important;
      white-space: nowrap;
      border-left: none !important;
      border-bottom: 3px solid transparent;
      min-width: 0; /* 允许缩小到最小宽度 */
      font-size: 14px;
    }

    .tab_chose {
      border-left: none !important;
      border-bottom: 3px solid #BA0B0B !important;
      background: #FEEFEF !important;
    }

    /* 内容区域 */
    .table_1, .table_2 {
      padding-left: 15px;
      padding-top: 15px;
      padding-right: 15px;
    }

    /* 个人资料表单 */
    .profile_row {
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 15px;
    }

    .profile_row_tx{
      flex-direction: row !important;
    }

    .profile_row > div:first-child {
      margin-bottom: 5px;
    }

    .nickname_box, .code_box {
      margin-top: 8px;

    }

    .inline_field {
      margin-right: 0;
      width: 100%;
      margin-bottom: 10px;
    }

    .el-input {
      width: 100% !important;
    }

    /* 密码重置表单 */
    .pwd_row {
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 15px;
    }

    .pwd_label {
      margin-bottom: 5px;
    }

    .pwd_input {
      width: 100% !important;
    }

    /* 表格 */
    .el-table {
      font-size: 12px;
    }

    .el-table-column {
      min-width: 80px !important;
    }

    /deep/ .el-message{
      width: 50px !important;
    }

    .top_box{
      margin-top: unset !important;
    }

  }

  @media (max-width: 480px) {
    .tk-confirm-dialog {
    width: 280px !important;
  }

  .tk-confirm-dialog .el-message-box__content {
    padding: 12px 15px;
    font-size: 13px;
  }

  .tk-confirm-dialog .el-message-box__btns {
    padding: 8px 15px 12px;
    gap: 8px;
  }

  .tk-confirm-dialog .el-button {
    min-width: 70px;
    height: 32px;
    font-size: 13px;
  }


  .tk-confirm-dialog .el-message-box__message {
    padding-left: 25px;
  }

    /deep/ .el-message{
      width: 50px !important;
    }
    .top_box{
      margin-top: unset !important;
    }
    div[style*="padding: 0 15%"] {
      padding: 0 3% !important;
    }
    .cz_user_box_t1{
      padding: unset !important;
    }

    .cz_user_box {
      padding: 8px !important;
      width: unset !important;
    }

    .cz_user_box > div:first-child {
      flex-direction: column;
      align-items: flex-start !important;
    }

    .avatar_box img {
      width: 30px !important;
      height: 30px !important;
    }

    .nickname_text {
      font-size: 14px !important;
    }

    .expiration_date_text {
      font-size: 11px !important;
    }

    .tab_btn {
      font-size: 14px !important;
      padding: 6px 4px !important;
      min-width: 0;
    }

    .table_1, .table_2 {
      padding-left: 10px;
      padding-top: 10px;
      padding-right: 10px;
    }

    .profile_label, .pwd_label {
      font-size: 13px !important;
      width: auto !important;
    }



    .el-table {
      font-size: 11px !important;
    }

    .sim_balnce_box .balance_text {
      font-size: 18px !important;
    }

    .sim_balnce_box .zjwb_text {
      font-size: 12px !important;
    }
  }


/*支付相关开始*/
.version_card_box {
  height: 150px;
  margin: 0 auto;
  border-bottom: solid 1px #EEEEEE;
  margin-bottom: 20px;
  text-align: center;
}

.version_card {
  text-align: center;
  width: 180px;
  height: 100px;
  padding-top: 20px;
  border-radius: 5px;
}

.version_pay_box {
  height: 180px;
  width: 400px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
}

.version_pay_qrcode {
  width: 140px;
  height: 155px;
  border: solid 1px #EEEEEE;
  padding: 10px;
  text-align: center;
  flex-shrink: 0;
}

.version_pay_right {
  width: 200px;
  height: 155px;
  padding-top: 20px;
  padding-left: 20px;
  flex: 1;
}

/* 支付弹窗响应式 */
@media (max-width: 768px) {
  .version_card_box {
    height: auto;
    padding: 20px 10px;
  }

  .version_card {
    width: 100% !important;
    max-width: 200px;
    height: 80px;
    padding-top: 15px;
    padding-bottom:15px;
  }

  .version_pay_box {
    height: auto;
    width: 100%;
    flex-direction: column;
    gap: 15px;
  }

  .version_pay_qrcode {
    width: 120px;
    height: 140px;
    margin: 0 auto;
  }

  .version_pay_right {
    width: 100%;
    height: auto;
    padding: 10px;
    text-align: center;
  }
}



</style>
<style>
  /* 申请开票弹窗响应式 */
  @media (max-width: 768px) {
  .tk-confirm-dialog {
    max-width: 90vw !important;
    width: 300px !important;
    margin: 0 auto;
  }

  .tk-confirm-dialog .el-message-box__content {
    padding: 15px 20px;
    font-size: 14px;
  }

  .tk-confirm-dialog .el-message-box__btns {
    padding: 10px 20px 15px;
    display: flex;
    justify-content: center;
    gap: 10px;
  }

  .tk-confirm-dialog .el-button {
    min-width: 80px;
    height: 36px;
    font-size: 14px;
  }



  .tk-confirm-dialog .el-message-box__message {
    padding-left: 30px;
    text-align: left;
  }

    .invoice-dialog {
      max-width: 90% !important;
      width: 320px !important;
      margin: 0 auto;
    }

    .invoice-dialog .el-dialog__header {
      padding: 15px 20px 10px !important;
      line-height: 1.5 !important;
    }

    .invoice-dialog .el-dialog__title {
      font-size: 16px !important;
      float: none !important;
      text-align: center;
      display: block;
      width: 100%;
    }

    .invoice-dialog .el-form {
      display: block !important;
      justify-content: normal !important;
    }

    .invoice-dialog .el-form-item {
      margin-bottom: 12px;
    }
    :deep(.invoice-dialog .el-form-item__label) {
      width: 100px !important;
      text-align: left !important;
      padding-right: 10px;
      font-size: 13px;
    }
    :deep(.el-dialog) {
      width: 90% !important;
    }
    .el-dialog{
      width: 90% !important;
    }


    .invoice-dialog .el-input {
      width: 100% !important;
    }

    .invoice-dialog .el-radio {
      margin-right: 15px;
    }

    .invoice-dialog .el-dialog__footer {
      padding: 10px 20px 15px !important;
      margin-top: -30px !important;
    }

    .invoice-dialog .el-button {
      min-width: 80px;
      height: 36px;
      font-size: 14px;
    }

    .invoice-dialog .el-form-item__label {
      width: 100px !important;
    }
    .kp_btn{
      margin-top: -20px !important;
      text-align: center;
    }

  }


</style>